import PropTypes from 'prop-types';

import CategoryTree from 'Component/CategoryTree';
import Icon from 'Component/Icon';
import { CategoryFilterOverlay as SourceCategoryFilterOverlay } from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.component';
import { CATEGORY_FILTER_OVERLAY_ID } from 'SourceComponent/CategoryFilterOverlay/CategoryFilterOverlay.config';
import Overlay from 'SourceComponent/Overlay';

import './CategoryFilterOverlay.override.style';

/** @namespace AdvoxBasic/Component/CategoryFilterOverlay/Component/CategoryFilterOverlay */
export class CategoryFilterOverlay extends SourceCategoryFilterOverlay {
    static propTypes = {
        ...SourceCategoryFilterOverlay.propTypes,
        isMobile: PropTypes.bool.isRequired,
        isTablet: PropTypes.bool.isRequired,
        appliedFiltersCount: PropTypes.number,
        onCloseFiltersClick: PropTypes.func.isRequired,
        heading: PropTypes.string,
    };

    renderCategoryTree() {
        const { heading } = this.props;

        return (
            <div block="CategoryFilterOverlay" elem="Attributes">
                <CategoryTree heading={heading} />
            </div>
        );
    }

    renderMobileHeading() {
        const { isContentFiltered, isMobile, isTablet, appliedFiltersCount, onCloseFiltersClick } = this.props;
        if (!isMobile && !isTablet) {
            return null;
        }

        return (
            <div block="CategoryFilterOverlay" elem="HeadingWrapper">
                <Icon name="filters" block="CategoryFilterOverlay" elem="Icon" mods={{ filters: true }} />
                <h3 block="CategoryFilterOverlay" elem="Heading" mods={{ isContentFiltered }}>
                    {__('Filters')}
                    {appliedFiltersCount > 0 && ` (${appliedFiltersCount})`}
                </h3>
                <button block="CategoryFilterOverlay" elem="Close" onClick={onCloseFiltersClick}>
                    <Icon name="close" />
                </button>
            </div>
        );
    }

    renderContent() {
        const { totalPages, isProductsLoading } = this.props;

        if (!isProductsLoading && totalPages === 0) {
            return this.renderEmptyFilters();
        }

        return (
            <>
                {this.renderDefaultFilters()}
                {this.renderSeeResults()}
            </>
        );
    }

    renderDefaultFilters() {
        const { isMobile, isTablet } = this.props;

        if (isMobile || isTablet) {
            return (
                <>
                    {this.renderMobileHeading()}
                    <div block="CategoryFilterOverlay" elem="ResetSection">
                        {this.renderResetAttributes()}
                        {this.renderResetButton()}
                    </div>
                    <div block="CategoryFilterOverlay" elem="FiltersWrap">
                        {this.renderCategoryTree()}
                        {this.renderFilters()}
                    </div>
                </>
            );
        }

        return (
            <>
                {this.renderMobileHeading()}
                <div block="CategoryFilterOverlay" elem="FiltersWrap">
                    {this.renderCategoryTree()}
                    {this.renderFilters()}
                </div>
            </>
        );
    }

    render() {
        const { onVisible, onHide, totalPages, isProductsLoading, isContentFiltered } = this.props;

        if (!isProductsLoading && totalPages === 0 && !isContentFiltered) {
            return <div block="CategoryFilterOverlay" />;
        }

        return (
            <Overlay
                onVisible={onVisible}
                onHide={onHide}
                mix={{ block: 'CategoryFilterOverlay' }}
                id={CATEGORY_FILTER_OVERLAY_ID}
                isRenderInPortal={false}
            >
                <div block="CategoryFilterOverlay" elem="Wrapper">
                    {this.renderContent()}
                    {this.renderLoader()}
                </div>
            </Overlay>
        );
    }
}

export default CategoryFilterOverlay;
